<template>
  <v-card elevation="2" class="item" height="100%" :to="to" flat>
    <v-container>
      <v-row class="align-center">
        <v-col cols="12" md="4">
          <img
            class="d-block item-img"
            :src="files + img + '?resize=1&w=360'"
            :alt="title"
            width="100%"
          />
        </v-col>
        <v-col cols="12" md="8">
          <h3>{{ title }}</h3>
          <div class="text-item" v-html="text"></div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-radius: 15px;
  .item-img {
    aspect-ratio: 1/1;
    object-fit: contain;
    border-radius: 15px;
  }
  .text-item {
    font-size: 14px;
    color: var(--v-text-base);
  }
}
</style>
